import Image from "next/image";
import { useRouter } from "next/router";

const BackButton = ({
  isAppWebView,
  color = "black",
  top = "top-4",
  left = "left-2",
}) => {
  return null;
  // const router = useRouter();
  // if (!isAppWebView) {
  //   return null;
  // }
  // return (
  //   <button
  //     onClick={() => router.back()}
  //     className={`absolute ${top} ${left} sm:left-0 flex p-2 rounded-full backdrop-blur-sm transition-all text-brand-black group z-20`}
  //   >
  //     <Image
  //       src={
  //         color == "white"
  //           ? "/icons/left-arrow-white.svg"
  //           : "/icons/left-arrow.svg"
  //       }
  //       alt="Geri"
  //       width={32}
  //       height={32}
  //     />
  //   </button>
  // );
};

export default BackButton;
